import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box, Icon, Typography, useTheme } from '@qbe/ads-core';
import React from 'react';

import { useAppContent } from '~/hooks';

export const LiabilityHelper = ({
  isLiabilityOnlyForPropertyOwner,
}: {
  isLiabilityOnlyForPropertyOwner: boolean;
}) => {
  const theme = useTheme();

  const { getTextContent } = useAppContent({
    basePath: 'dsme.selectCover.fields.businessLiability',
  });
  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        border: '1px solid #e0e3e7',
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px',
        position: 'relative',
        height: '220px',
        width: '100%',
      }}
    >
      <Box sx={{ position: 'absolute', top: 0, left: 0, padding: '16px' }}>
        <Icon muiIcon={InfoOutlined} color={theme.palette.text.primary} />
      </Box>
      <Typography variant="body2" textAlign="center">
        {getTextContent(
          isLiabilityOnlyForPropertyOwner ? 'liabilityHelperProperty' : 'liabilityHelperBusiness'
        )}
      </Typography>
    </Box>
  );
};
